import ListingsRoutingResolver from './ListingRoutingResolver';

class PurCreditNoteListingResolver extends ListingsRoutingResolver {
    constructor() {
        super();
        this.key = 'purchasecreditnotes';
    }
}

export default PurCreditNoteListingResolver;
